import React, { useCallback } from 'react';
import { DateTime } from 'luxon';
import { Checkbox, FileSelectCard, makeStyles } from "../../index";
import { useTranslation } from "../../hooks/useTranslation";
import { pathToPmlEditPage } from "../../helpers/route-helpers";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        position: 'relative',
        display: 'flex',
    },
    checkbox: {
        position: 'absolute',
        left: theme.spacing(1),
        top: theme.spacing(1),
    },
}); });
/**
 * ファイルのカードに表示する日時の文字列を返す
 * @param createdDatetime
 * @param updatedDatetime
 * @param sortItem
 */
var datetimeString = function (sort, createdDatetime, updatedDatetime, t) {
    return sort === 'CREATED_DATETIME'
        ? createdDatetime.toFormat(DateTime.local().get('year') === createdDatetime.get('year')
            ? t('作成 LL月dd日 HH:mm')
            : t('作成 yyyy年LL月dd日'))
        : updatedDatetime.toFormat(DateTime.local().get('year') === updatedDatetime.get('year')
            ? t('更新 LL月dd日 HH:mm')
            : t('更新 yyyy年LL月dd日'));
};
/**
 * `開く`をクリックした時に開くタブのURLを指定する
 */
var openLink = function (pmlFile) {
    return pathToPmlEditPage(pmlFile.kind, pmlFile.id);
};
/**
 * FileSelectCardをファイルで使用する用にラップするコンポーネント
 */
export var PmlFileSelectCard = function (props) {
    var pmlFile = props.pmlFile, selected = props.selected, sort = props.sort, isMultipleSelection = props.isMultipleSelection, showOwnerName = props.showOwnerName, thumbnailPath = props.thumbnailPath, onSelectPmlFile = props.onSelectPmlFile;
    var classes = useStyles();
    var t = useTranslation().t;
    var handleClick = useCallback(function () {
        onSelectPmlFile(pmlFile, selected);
    }, [pmlFile, selected, onSelectPmlFile]);
    return (React.createElement("div", { className: classes.root },
        React.createElement(FileSelectCard, { title: showOwnerName ? pmlFile.ownerName : pmlFile.title, subtitle: datetimeString(sort, pmlFile.createdDatetime, pmlFile.updatedDatetime, t), thumbnailLink: thumbnailPath, openLink: openLink(pmlFile), selected: selected, isLinkedAssignment: !!pmlFile.linkedAssignmentId, onSelect: handleClick }),
        isMultipleSelection && (React.createElement("div", { className: classes.checkbox },
            React.createElement(Checkbox, { value: selected, onClick: handleClick })))));
};
